import { render, staticRenderFns } from "./BotPage.vue?vue&type=template&id=6b1d1d1c&scoped=true&"
import script from "./BotPage.vue?vue&type=script&lang=js&"
export * from "./BotPage.vue?vue&type=script&lang=js&"
import style0 from "./BotPage.vue?vue&type=style&index=0&id=6b1d1d1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1d1d1c",
  null
  
)

export default component.exports